import { sa } from './sa'

export const handleIdentify = ({
  userId,
  emailSha256,
}: {
  userId: string
  emailSha256: string
}) => {
  sa.updateUserId(userId)
  sa.updateEmail(emailSha256)
}
